import { render, staticRenderFns } from "./VideoGuest.vue?vue&type=template&id=19f9f5b8&scoped=true&"
import script from "./VideoGuest.vue?vue&type=script&lang=js&"
export * from "./VideoGuest.vue?vue&type=script&lang=js&"
import style0 from "./VideoGuest.vue?vue&type=style&index=0&id=19f9f5b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9f5b8",
  null
  
)

export default component.exports